const datepickerTime = document.querySelector('.date-picker');
let body = $('body');

if(datepickerTime) {
    initDatePickerTime();
}

export function initDatePickerTime() {
    body.find('.date-picker').datetimepicker({
        format: 'd.m.Y H:i',
        inline: false,
        lang: 'uk',
        minTime: '07:00',
        maxTime: '22:00',
        style: 'width:340px'
    });
    $.datetimepicker.setLocale('uk');
}
